import { RiFlag2Line } from "@remixicon/react";
import {
  Badge,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@tremor/react";
import { useEffect, useState } from "react";
import { baseImgURL, baseURL } from "./backend/baseData";
import axios from "axios";
import { Link } from "react-router-dom";

const data = [
  {
    name: "Viola Amherd",
    Role: "Federal Councillor",
    departement:
      "The Federal Department of Defence, Civil Protection and Sport (DDPS)",
    status: "active",
  },
  {
    name: "Albert Rösti",
    Role: "Federal Councillor",
    departement:
      "The Federal Department of the Environment, Transport, Energy and Communications (DETEC)",
    status: "active",
  },
  {
    name: "Beat Jans",
    Role: "Federal Councillor",
    departement: "The Federal Department of Justice and Police (FDJP)",
    status: "active",
  },
  {
    name: "Ignazio Cassis",
    Role: "Federal Councillor",
    departement: "The Federal Department of Foreign Affairs (FDFA)",
    status: "active",
  },
  {
    name: "Karin Keller-Sutter",
    Role: "Federal Councillor",
    departement: "The Federal Department of Finance (FDF)",
    status: "active",
  },
  {
    name: "Guy Parmelin",
    Role: "Federal Councillor",
    departement:
      "The Federal Department of Economic Affairs, Education and Research (EAER)",
    status: "active",
  },
  {
    name: "Elisabeth Baume-Schneider",
    Role: "Federal Councillor",
    departement: "The Federal Department of Home Affairs (FDHA)",
    status: "active",
  },
];

export function UnpublishedChallenges() {
  const [unPublished, setUnPublished] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchunPublished = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getInactiveChallengesNormal.php?id=2`
        );
        console.log(response)
        if (response.status === 200 && Array.isArray(response.data)) {
          console.log(response.data);
          setUnPublished(response.data);
        } else {
          console.error(
            "Invalid response format or failed to fetch unPublished"
          );
          setUnPublished([]);
        }
      } catch (error) {
        console.error("Error while fetching unPublished:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchunPublished();
  }, []);
  return (
    <div className="w-full flex-grow p-3">
      <div>Navbar</div>
      <div className="w-full">
        <Card>
          <h3 className="text-tremor-content-strong dark:text-dark-tremor-content-strong font-semibold">
            Unpublished Challenges
          </h3>
          <Table className="mt-5">
            <TableHead>
              <TableRow>
                <TableHeaderCell>Image</TableHeaderCell>
                <TableHeaderCell>Title</TableHeaderCell>
                <TableHeaderCell>Description</TableHeaderCell>
                <TableHeaderCell>View</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {unPublished?.length > 0 &&
                unPublished.map((item, index) => (
                  <TableRow key={item.index}>
                    <TableCell>
                      <div className="p-2 bg-white shadow rounded-md w-fit">
                        <img src={baseImgURL + item.image} className="w-20 h-20 rounded-md" />
                      </div>
                    </TableCell>
                    <TableCell>{item.title}</TableCell>
                    <TableCell>{item.description && item.description.length > 150
                        ? `${item.description.substring(0, 150)}...`
                        : item.description}</TableCell>
                    <TableCell>
                      <Link to={`/view/${item.challenge_id}`} className="bg-blue-500 p-2 text-white rounded-md">
                      View Details
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </div>
  );
}
